var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 481,
    viewBox: "0 0 544 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.38 110.448L161.994 129.698L83.1904 83.9801L117.78 64.7305L195.38 110.448Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.38 212.111L161.994 231.361L83.1904 185.643L117.78 166.394L195.38 212.111Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.189 212.111L161.803 231.361L83 185.643L117.589 166.394L195.189 212.111Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.993 129.699V231.361",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.08 64.7305V166.393L83.2236 185.609V83.9467",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.38 110.115V211.777",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.919 148.013L95.5328 167.262L16.7295 121.545L51.3187 102.295L128.919 148.013Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.919 249.675L95.5328 268.925L16.7295 223.207L51.3187 203.957L128.919 249.675Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.729 249.675L95.3433 268.925L16.54 223.207L51.1293 203.957L128.729 249.675Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5342 167.263V268.925",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6202 102.295V203.957L16.7637 223.173V121.511",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.919 147.679V249.341",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.246 161.28L374.86 180.53L296.057 134.812L330.646 115.562L408.246 161.28Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M408.246 262.943L374.86 282.192L296.057 236.474L330.646 217.225L408.246 262.943Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.057 262.943L374.67 282.192L295.867 236.474L330.456 217.225L408.057 262.943Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M374.86 180.529V282.192",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330.946 115.562V217.225L296.09 236.441V134.779",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.247 160.946V262.609",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.7 218.639L478.314 237.888L399.511 192.171L434.1 172.921L511.7 218.639Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.7 320.301L478.314 339.551L399.511 293.833L434.1 274.583L511.7 320.301Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.511 320.301L478.125 339.551L399.321 293.833L433.911 274.583L511.511 320.301Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.314 237.889V339.551",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.402 172.921V274.583L399.545 293.799V192.137",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.7 218.305V319.967",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.524 92.5236L255.911 111.773L334.714 66.0553L300.125 46.8057L222.524 92.5236Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.524 194.186L255.911 213.435L334.714 167.717L300.125 148.468L222.524 194.186Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.715 194.186L256.101 213.435L334.904 167.717L300.315 148.468L222.715 194.186Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M255.911 111.773V213.436",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M299.824 46.8057V148.468L334.681 167.684V66.0219",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.524 92.1904V193.853",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.05 46.7179L182.436 65.9676L261.239 20.2496L226.65 1L149.05 46.7179Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05 148.38L182.436 167.63L261.239 121.912L226.65 102.662L149.05 148.38Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.239 148.38L182.625 167.63L261.429 121.912L226.839 102.662L149.239 148.38Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.437 65.9678V167.63",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.35 1V102.662L261.206 121.878V20.2162",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05 46.3838V148.046",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.541 358.981L260.927 378.23L339.73 332.512L305.141 313.263L227.541 358.981Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.541 460.643L260.927 479.892L339.73 434.174L305.141 414.925L227.541 460.643Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73 460.643L261.117 479.892L339.92 434.174L305.331 414.925L227.73 460.643Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.928 378.23V479.893",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.841 313.263V414.925L339.697 434.141V332.479",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.541 358.646V460.309",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.993 313.386L195.379 332.636L274.183 286.918L239.593 267.668L161.993 313.386Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.993 415.048L195.379 434.298L274.183 388.58L239.593 369.33L161.993 415.048Z",
    stroke: "#231F20",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M162.184 415.048L195.57 434.298L274.373 388.58L239.784 369.33L162.184 415.048Z",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.38 332.635V434.297",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.292 267.668V369.33L274.149 388.546V286.884",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M161.993 313.051V414.713",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8877 106.094L531.211 392.534",
    stroke: "white",
    strokeWidth: 12.5461,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.319 358.727L360.218 419.903L109.78 274.611L219.705 213.436L466.319 358.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 336.395L117.925 275.22",
    stroke: "white",
    strokeWidth: 12.5461,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3313 312.71L8 335.62L31.6433 343.501",
    stroke: "white",
    strokeWidth: 12.5461,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.898 400.558L536.186 394.533L530.235 370.332",
    stroke: "white",
    strokeWidth: 12.5461,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6421 94.2568L38.7041 104.123L48.6519 126.974",
    stroke: "white",
    strokeWidth: 12.5461,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M406.997 298.176L263.646 382.425",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10,
    strokeDasharray: "4.33 4.33"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M313.519 246.485L268.452 272.971",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10,
    strokeDasharray: "4.33 4.33"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M359.836 324.488L177.07 222.291",
    stroke: "white",
    strokeWidth: 1.56826,
    strokeMiterlimit: 10,
    strokeDasharray: "4.33 4.33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.176e91562ac20e225c382a1298958f26.svg";
export { ForwardRef as ReactComponent };